module.exports = __webpack_public_path__ + "static/media/IK_GIF2.360b3a31.gif";